import _ from 'lodash'
import type {DocumentManager} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import {rgb2hex, str2rgba, isRgb, isRgba} from '@wix/color-kit'
import type {PageMigrator} from '../dataMigrationRunner'
import {ReportableError} from '@wix/document-manager-utils'

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    const {dal, pointers, experimentInstance} = documentManager

    const backgroundMediaPointers = pointers.data
        .getDataItemsWithPredicate(data => data.type === 'BackgroundMedia', pageId)
        .concat(pointers.data.getDesignItemsWithPredicate(design => design.type === 'BackgroundMedia', pageId))

    _.forEach(backgroundMediaPointers, (backgroundMediaPointer: Pointer) => {
        const backgroundMedia = dal.get(backgroundMediaPointer)

        if (isRgb(backgroundMedia.color) || isRgba(backgroundMedia.color)) {
            const rgba = str2rgba(backgroundMedia.color)
            const hex = rgb2hex(rgba[0], rgba[1], rgba[2])
            const alpha = rgba[3]
            dal.set(backgroundMediaPointer, {
                ...backgroundMedia,
                color: hex,
                ...(alpha && {colorOpacity: alpha})
            })
            return
        }

        if (experimentInstance.isOpen('dm_strictBackgroundMediaValidation') && backgroundMedia.color) {
            try {
                documentManager.dal.schema.validateStrict(
                    'BackgroundMedia',
                    backgroundMedia,
                    backgroundMediaPointer.type
                )
            } catch (error) {
                documentManager.logger.captureError(
                    new ReportableError({
                        message: `Fixed invalid BackgroundMedia color: ${backgroundMedia.color} -> transparent`,
                        errorType: 'invalidBackgroundMediaColor',
                        extras: {
                            originalColor: backgroundMedia.color,
                            fixedColor: 'transparent',
                            itemId: backgroundMedia.id,
                            namespace: backgroundMediaPointer.type,
                            pageId
                        }
                    })
                )

                dal.set(backgroundMediaPointer, {
                    ...backgroundMedia,
                    color: 'transparent'
                })
            }
        }
    })
}

const name = 'fixInvalidBackgroundMediaColor'
const version = 2
const experimentalVersions = [{experiment: 'dm_strictBackgroundMediaValidation', version: 3}]

export const fixInvalidBackgroundMediaColor: PageMigrator = {
    migratePage,
    name,
    version,
    experimentalVersions
}
